import React, { useState, useEffect, useCallback } from "react";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import {
    Button, FormControl, MenuItem, TableRow, Table, TableHead,
    TableBody, TableCell, TableContainer, Paper, Card, Box,
    Select, TextField, Typography, IconButton, InputAdornment,
    Tooltip, Avatar,
} from "@material-ui/core";
import ExportExcel from "../../Excelexport";
import AttendenceService from "./Locality/Service/attendenceService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import StudentService from "./Locality/Service/studentService";
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core/styles';
import FilterPanel, { FilterSection } from '../../components/ui/FilterPanel';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme) => ({
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#1a1a1a',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#555',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#e6e6e6',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1a1a1a',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersRow: {
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        width: '100%',
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 40,
        boxSizing: 'border-box',
        padding: '0 12px',
        borderRadius: 8,
        border: '1px solid #8f8f8f',
        backgroundColor: '#fff',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#1a1a1a',
        userSelect: 'none',
        flexShrink: 0,
    },
    countBadge: {
        backgroundColor: '#1a1a1a',
        color: '#fff',
        borderRadius: 10,
        fontSize: '0.72rem',
        fontWeight: 700,
        minWidth: 18,
        height: 18,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 5px',
    },
    fieldLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#444',
        marginBottom: 6,
        minHeight: 18,
        lineHeight: '18px',
    },
    filterFieldWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 0',
        minWidth: 150,
    },
    filterActionsWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '0 0 auto',
        justifyContent: 'flex-end',
    },
    primaryBtn: {
        backgroundColor: '#1a1a1a',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#444',
        border: '1px solid #d9d9d9',
        height: 40,
        minWidth: 88,
        padding: '0 16px',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #d9d9d9',
    },
    iconBtnOutlined: {
        border: '1px solid #d9d9d9',
        borderRadius: 8,
        padding: 7,
    },
    headCell: {
        backgroundColor: '#efefef',
        color: '#444',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #d9d9d9',
        whiteSpace: 'nowrap',
    },
    studentAvatar: {
        width: 28,
        height: 28,
        fontSize: '0.72rem',
        fontWeight: 700,
        backgroundColor: '#1a1a1a',
        color: '#fff',
    },
    statPill: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        fontWeight: 600,
        fontSize: '0.82rem',
    },
}));

export default function Reports() {
    const classes = useStyles();
    const [result, setResult] = useState([]);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(1000);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [studentId, setStudentId] = useState("");
    const [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [getReport, setGetReport] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const excelExport = (res) => {
        const exportResult = res.map((response) => ({
            "Student Name": response.studentName,
            "Count": response.count,
            "Date": response.present,
            "Absent": response.absent,
            "Late Coming": response.lateComing || 0,
            "Early Going": response.earlyGoing || 0,
        }));
        setResult(exportResult);
    };

    const fetchReport = useCallback(() => {
        if (!classId) return;

        const report = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : null;
        const newendDate1 = endDate1 ? endDate1 : null;

        const keys = {
            "schooleId": report.schoolId,
            "studentId": studentId,
            "startDate1": newstartDate1,
            "endDate1": newendDate1,
            "classId": classId,
            "sectionId": sectionId || userDetails.sectionId || undefined,
        };
        AttendenceService.getStuAttReport(keys).then((res) => {
            excelExport(res);
            setGetReport(Array.isArray(res) ? res : []);
            setpg(0);
        }).catch(() => {});
    }, [classId, sectionId, studentId, startDate1, endDate1, userDetails.sectionId]);

    useEffect(() => {
        fetchReport();
    }, [fetchReport]);

    useEffect(() => {
        getAddClassList();
        return () => {
            setStudentList([]);
            setGetReport([]);
        };
    }, []);

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const activeFilterCount =
        (classId ? 1 : 0) +
        (sectionId ? 1 : 0) +
        (studentId ? 1 : 0) +
        (startDate1 ? 1 : 0) +
        (endDate1 ? 1 : 0);

    const handleResetFilters = () => {
        setStudentId("");
        setStartDate1("");
        setEndDate1("");
        setSearchTerm("");
        setpg(0);
        if (addClassList.length > 0) {
            const initialClassId = userDetails.role === "TEACHER" && userDetails.classId
                ? userDetails.classId
                : addClassList[0]._id;
            setClassId(initialClassId);
            const initialSectionId = userDetails.role === "TEACHER" ? (userDetails.sectionId || "") : "";
            setSectionId(initialSectionId);
            getSectionListByClass(initialClassId);
            getStudentList({ target: { value: initialClassId } }, initialSectionId || undefined);
        }
    };

    const filteredReport = getReport.filter((row) => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return true;
        return (row.studentName || "").toLowerCase().includes(term);
    });

    const studentInitials = (name) => {
        if (!name) return "?";
        const parts = String(name).split(" ").filter(Boolean);
        if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        return String(name).slice(0, 2).toUpperCase();
    };

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            setAddClassList(list);
            if (list.length > 0) {
                const initialClassId = userDetails.role === "TEACHER" && userDetails.classId
                    ? userDetails.classId
                    : list[0]._id;
                setClassId(initialClassId);
                const initialSectionId = userDetails.role === "TEACHER" ? (userDetails.sectionId || "") : "";
                setSectionId(initialSectionId);
                getSectionListByClass(initialClassId);
                getStudentList({ target: { value: initialClassId } }, initialSectionId || undefined);
            }
        }).catch(() => {});
    };

    const onSubmit = () => {
        fetchReport();
    };

    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = (event && event.target) ? event.target.value : classId;
        if (!selectedClassId) return;

        const body = { classId: selectedClassId };
        const effectiveSectionId =
            overrideSectionId !== undefined
                ? overrideSectionId
                : (sectionId || userDetails.sectionId || undefined);
        if (effectiveSectionId) {
            body.sectionId = effectiveSectionId;
        }

        setClassId(selectedClassId);
        StudentService.getAllStudentById(userDetails.schooleId, body)
            .then((res) => {
                const studentDetails = res.map((s) => ({
                    _id: s._id,
                    studentName: `${s.firstName} ${s.lastName}`,
                    status: true,
                }));
                setStudentList(studentDetails);
            })
            .catch(() => {});
    };

    return (
        <Box p={{ xs: 1, sm: 2 }}>
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Attendance Reports</Typography>
                    <Typography className={classes.pageSubtitle}>
                        View student attendance summary by class, section, and date range.
                    </Typography>
                </Box>
            </Box>


            <Card elevation={0} className={classes.tableCard}>
                <Box className={classes.toolbar}>
                    <Typography style={{ fontWeight: 700, color: '#1a1a1a' }}>
                        {filteredReport.length} Record{filteredReport.length !== 1 ? 's' : ''}
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search students..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setpg(0);
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ fontSize: 18, color: '#8a8a8a' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                          variant="outlined"
                          startIcon={<FilterListIcon fontSize="small" />}
                          onClick={() => setFiltersOpen((o) => !o)}
                          aria-pressed={filtersOpen}
                          style={filtersOpen ? { backgroundColor: '#e6e6e6' } : undefined}
                        >
                          Filters
                          {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
                        </Button>
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} size="small" onClick={onSubmit}>
                                <RefreshIcon style={{ fontSize: 20, color: '#444' }} />
                            </IconButton>
                        </Tooltip>
                        <ExportExcel excelData={result} fileName={'Student Activity'} />
                    </Box>
                </Box>

                <Box display="flex" alignItems="stretch" flexWrap="wrap">
                <Box flex="1 1 520px" minWidth={0}>
                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.headCell}>Student Name</TableCell>
                                <TableCell className={classes.headCell} align="center">Working Days</TableCell>
                                <TableCell className={classes.headCell} align="center">Days Present</TableCell>
                                <TableCell className={classes.headCell} align="center">Days Absent</TableCell>
                                <TableCell className={classes.headCell} align="center">Late Coming</TableCell>
                                <TableCell className={classes.headCell} align="center">Early Going</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredReport.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" style={{ padding: 32, color: '#8a8a8a' }}>
                                        No attendance records found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredReport.slice(pg * rpg, pg * rpg + rpg).map((report, idx) => (
                                    <TableRow key={report._id || `${report.studentName}-${idx}`} hover>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" gridGap={8}>
                                                <Avatar className={classes.studentAvatar}>
                                                    {studentInitials(report.studentName)}
                                                </Avatar>
                                                <Typography style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '0.875rem' }}>
                                                    {report.studentName}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">{report.count}</TableCell>
                                        <TableCell align="center">
                                            <span className={classes.statPill} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }}>
                                                {report.present}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center">
                                            <span className={classes.statPill} style={{ backgroundColor: '#ffebee', color: '#b3261e' }}>
                                                {report.absent}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center">{report.lateComing || 0}</TableCell>
                                        <TableCell align="center">{report.earlyGoing || 0}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    rowsPerPageOptions={[1000, 10000, 100000]}
                    count={filteredReport.length}
                    page={pg}
                    onPageChange={handleChangePage}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </Box>
                {filtersOpen && (
                    <FilterPanel onReset={handleResetFilters}>
                    <FilterSection title="Class" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <Select
                                    displayEmpty
                                    name="classId"
                                    value={classId}
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        setClassId(selected);
                                        setSectionId("");
                                        getSectionListByClass(selected);
                                        getStudentList(e, undefined);
                                    }}
                                >
                                    <MenuItem value=""><em>Select Class</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Section (Optional)" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                            <FormControl variant="outlined" size="small" fullWidth disabled={!classId || sectionList.length === 0}>
                                <Select
                                    displayEmpty
                                    value={sectionId}
                                    onChange={(e) => {
                                        const newSectionId = e.target.value;
                                        setSectionId(newSectionId);
                                        if (classId) {
                                            getStudentList({ target: { value: classId } }, newSectionId || undefined);
                                        }
                                    }}
                                >
                                    <MenuItem value=""><em>All Sections</em></MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Student" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <Select
                                    displayEmpty
                                    name="studentId"
                                    value={studentId}
                                    onChange={(e) => setStudentId(e.target.value)}
                                >
                                    <MenuItem value=""><em>All Students</em></MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Start Date">
                            <SchoolDatePicker
                                value={startDate1}
                                onChange={(iso) => setStartDate1(iso)}
                            />
                    </FilterSection>
                    <FilterSection title="End Date">
                            <SchoolDatePicker
                                value={endDate1}
                                onChange={(iso) => setEndDate1(iso)}
                            />
                    </FilterSection>
                    </FilterPanel>
                )}
                </Box>
            </Card>
        </Box>
    );
}
